// extracted by mini-css-extract-plugin
module.exports = {"body":"InputLogin_body__2B5zk"};